import { render, staticRenderFns } from "./VendorContracts.vue?vue&type=template&id=4f5b3294&scoped=true"
import script from "./VendorContracts.vue?vue&type=script&lang=ts"
export * from "./VendorContracts.vue?vue&type=script&lang=ts"
import style0 from "./VendorContracts.vue?vue&type=style&index=0&id=4f5b3294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5b3294",
  null
  
)

export default component.exports